export default function NotFound() {
    return (
        <div>
            <h1 className="title">Page not found</h1>
        </div>
    );
}